<template>
  <HomeInicio />

  <div v-if="paquete === 3 || paquete === 4" class="container">
    <!-- Filtros y Totales al lado derecho -->
    <div class="header-bar">
      <div class="filters tooltip-container">
  <input
    id="filterNombre"
    v-model="filterNombre"
    type="text"
    placeholder="Filtrar por nombre o nombre mostrar"
    class="input-filtro"
  />
  <span class="tooltip-icon">?</span>
  <div class="custom-tooltip">
    Puedes buscar por:<br />
    <strong>nombre</strong>, <strong>nombre mostrar</strong>, <strong>confirmado</strong>, <strong>sin confirmar</strong>
  </div>
</div>


      <div class="invitados-count">
        <p>Total de Invitados: <strong>{{ invitadosFiltrados.length }}</strong></p>
<p>Total de Pases: <strong>{{ totalPases }}</strong></p>

      </div>

      <button class="btn btn-download" @click="descargarExcel">
        <img src="@/assets/excel.png" alt="Descargar Excel" class="download-icon" />
        Descargar Excel
      </button>
    </div>

    <!-- Tabla -->
    <div :class="['add-invitados-container', { compact: !mostrarTodo }]">
      <h2 class="title">Mis Invitados</h2>
  
      <p class="description">A continuación se muestran los registros cargados desde el archivo Excel. Puedes agregar más invitados o editar los existentes.</p>
      <button
  v-if="!vistaTarjetas"
  class="btn btn-outline"
  @click="mostrarTodo = !mostrarTodo"
>
  {{ mostrarTodo ? 'Ocultar columnas' : 'Mostrar todo' }}
</button>

<button class="btn btn-outline" @click="vistaTarjetas = !vistaTarjetas">
  {{ vistaTarjetas ? 'Ver en tabla' : 'Ver en tarjetas' }}
</button>

<div class="agregar-btn-wrapper">
  <button class="btn-agregar-invitado" @click="abrirModalAgregar">
    <span class="icono-mas">＋</span> Agregar Invitado
  </button>
</div>

   
<!-- Vista TABLA -->
<div v-if="!vistaTarjetas" class="table-wrapper">
  <table class="table">
    <thead>
      <tr>
        <th>Status</th>
        <th>#</th>
        <th v-if="mostrarTodo">Nombre</th>
        <th v-if="mostrarTodo">Apellido P</th>
        <th v-if="mostrarTodo">Apellido M</th>
        <th>Nombre Mostrar</th>
        <th>Num Pase</th>
        <th>Num Mesa</th>
        <th v-if="mostrarTodo">Telefono</th>
        <th>Url</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(invitado, index) in invitadosFiltrados" :key="invitado.id_invitado">
        <td>
          <span v-if="invitado.asistira === 'si'" class="badge-confirmado">Confirmado</span>
          <span
            v-else
            class="badge-sinconfirmar"
            :class="{ disabled: !invitado.telefono }"
            :title="invitado.telefono ? 'Enviar WhatsApp' : 'Teléfono no disponible'"
            @click="abrirWhatsApp(invitado)"
            style="cursor: pointer;"
          >
            Sin confirmar
          </span>
        </td>
        <td>{{ index + 1 }}</td>
        <td v-if="mostrarTodo">
          <input v-if="invitado.isEditing" v-model="invitado.nombre_invitado" type="text" />
          <span v-else>{{ invitado.nombre_invitado }}</span>
        </td>
        <td v-if="mostrarTodo">
          <input v-if="invitado.isEditing" v-model="invitado.apellidop_invitado" type="text" />
          <span v-else>{{ invitado.apellidop_invitado }}</span>
        </td>
        <td v-if="mostrarTodo">
          <input v-if="invitado.isEditing" v-model="invitado.apellidom_invitado" type="text" />
          <span v-else>{{ invitado.apellidom_invitado }}</span>
        </td>
        <td>
          <input v-if="invitado.isEditing" v-model="invitado.nombre_mostrar" type="text" />
          <span v-else>{{ invitado.nombre_mostrar }}</span>
        </td>
        <td>
          <input v-if="invitado.isEditing" v-model="invitado.num_pase" type="number" />
          <span v-else>{{ invitado.num_pase }}</span>
        </td>
        <td>
          <input v-if="invitado.isEditing" v-model="invitado.num_mesa" type="number" />
          <span v-else>{{ invitado.num_mesa }}</span>
        </td>
        <td v-if="mostrarTodo">
          <input v-if="invitado.isEditing" v-model="invitado.telefono" type="text" />
          <span v-else>{{ invitado.telefono }}</span>
        </td>
        <td class="url-cell">
          <a
            v-if="nombre_pagina && idFestejada"
            :href="generarLinkWhatsApp(invitado)"
            target="_blank"
            class="link-whatsapp"
            style="text-decoration: none; color: inherit;"
          >
            {{ nombre_pagina }}/{{ idFestejada }}/{{ invitado.id_invitado }}
          </a>
          <span v-else>Información no disponible</span>
        </td>
        <td>
          <div class="action-buttons">
            <button v-if="!invitado.isEditing" class="btn btn-outline" @click="editarInvitado(invitado)">Editar</button>

            <button v-if="invitado.isEditing" class="btn btn-outline" @click="guardarEdicion(invitado)">Guardar</button>
            <button class="btn btn-outline-secondary" @click="copiarUrl(invitado)">Copiar URL</button>
            <button
  class="btn btn-success"
  v-if="nombre_pagina && idFestejada"
  :title="`Enviar WhatsApp a ${invitado.nombre_mostrar}`"
  @click="abrirWhatsAppEnNuevaVentana(invitado)"
>
  <i class="fab fa-whatsapp"></i>
</button>

<button class="btn-borrar-personalizado" @click="confirmarBorrado(invitado)">
  <i class="fas fa-trash-alt"></i>
</button>

          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Vista TARJETAS -->
<div v-else class="tarjetas-wrapper">
  <div
    v-for="(invitado, index) in invitadosFiltrados"
    :key="invitado.id_invitado"
    class="tarjeta-invitado"
    :ref="el => tarjetaRefs[index] = el"
  >
    <div class="status-badge">
      <span v-if="invitado.asistira === 'si'" class="badge-confirmado">Confirmado</span>
      <span v-else class="badge-sinconfirmar">Sin confirmar</span>
    </div>
<!-- nombre_mostrar -->
<span class="nombre-mostrar-tag">
  <template v-if="invitado.isEditing">
    <input v-model="invitado.nombre_mostrar" type="text" />
  </template>
  <template v-else>
    {{ invitado.nombre_mostrar }}
  </template>
</span>

<!-- PASES -->
<p><br>


  <i class="fas fa-user"></i>
  <strong> Pases:</strong>
  <template v-if="invitado.isEditing">
    <input v-model="invitado.num_pase" type="number" />
  </template>
  <template v-else>
    {{ invitado.num_pase }}
  </template>
</p>

<!-- MESA -->
<p>
  <i class="fas fa-chair"></i>
  <strong> Mesa:</strong>
  <template v-if="invitado.isEditing">
    <input v-model="invitado.num_mesa" type="number" />
  </template>
  <template v-else>
    <span class="mesa-circle">{{ invitado.num_mesa || '—' }}</span>
  </template>
</p>

<!-- TELÉFONO -->
<p>
  <i class="fas fa-phone-alt phone-icon"></i>
  <strong> Teléfono:</strong>
  <template v-if="invitado.isEditing">
    <input v-model="invitado.telefono" type="text" />
  </template>
  <template v-else>
    <span class="telefono-rojo">{{ invitado.telefono || 'No registrado' }}</span>
  </template>
</p>

    <p><strong>URL:</strong><br />
      <a
        v-if="nombre_pagina && idFestejada"
        :href="generarLinkWhatsApp(invitado)"
        target="_blank"
      >
        {{ nombre_pagina }}/{{ idFestejada }}/{{ invitado.id_invitado }}
      </a>
    </p>

    <div class="action-buttons">
<!-- Botón editar -->
<button
  class="btn btn-outline"
  v-if="!invitado.isEditing"
  @click="editarInvitado(invitado)"
>
  Editar
</button>

<!-- Botón guardar con color distinto -->
<button
  class="btn btn-guardar"
  v-else
  @click="guardarEdicion(invitado)"
>
  Guardar
</button>



      <button class="btn btn-outline-secondary" @click="copiarUrl(invitado)">Copiar URL</button>
         <button
  class="btn btn-success"
  v-if="nombre_pagina && idFestejada"
  :title="`Enviar WhatsApp a ${invitado.nombre_mostrar}`"
  @click="abrirWhatsAppEnNuevaVentana(invitado)"
>
  <i class="fab fa-whatsapp"></i>
</button>
      <button class="btn-borrar-personalizado" @click="confirmarBorrado(invitado)">
  <i class="fas fa-trash-alt"></i>
</button>

    </div>
  </div>
</div>

      <p v-if="invitadosFiltrados.length === 0" class="description">No hay invitados cargados. Sube un archivo Excel para agregar invitados.</p>
    </div>

   
  </div>

  <div v-else class="nodisponible">
    <p>Esta sección no está disponible en el paquete contratado.</p> 
  </div>

  <!-- MODAL PARA AGREGAR INVITADO -->
<div v-if="modalAgregarVisible" class="modal-overlay">
  <div class="modal-contenido">
    <div class="modal-header">
      <h3 class="form-title">Agregar Invitado</h3>
      <button class="btn-cerrar" @click="modalAgregarVisible = false">×</button>
    </div>

    <form @submit.prevent="agregarInvitado">
      <!-- Copia aquí tu formulario existente tal cual -->
      <div class="form-row">
        <div class="form-group">
          <label for="nombre">Nombre</label>
          <input id="nombre" v-model="nuevoInvitado.nombre_invitado" type="text" required />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="apellidoP">Apellido Paterno</label>
          <input id="apellidoP" v-model="nuevoInvitado.apellidop_invitado" type="text" required />
        </div>
        <div class="form-group">
          <label for="apellidoM">Apellido Materno</label>
          <input id="apellidoM" v-model="nuevoInvitado.apellidom_invitado" type="text" required />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="nombreMostrar">Nombre Mostrar</label>
          <input id="nombreMostrar" v-model="nuevoInvitado.nombre_mostrar" type="text" required />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="numPase">Num Pase</label>
          <input id="numPase" v-model="nuevoInvitado.num_pase" type="text" required />
        </div>
        <div class="form-group">
          <label for="numMesa">Num Mesa</label>
          <input id="numMesa" v-model="nuevoInvitado.num_mesa" type="text" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="telefono">Teléfono</label>
          <input id="telefono" v-model="nuevoInvitado.telefono" type="tel" />
        </div>
      </div>

      <button type="submit" class="btn btn-success">Agregar Invitado</button>
    </form>
  </div>
</div>

</template>

  
  <script>
  import HomeInicio from "@/components/HomeInicio.vue"; // Importa tu header
  import baseUrl from '../api';  
  import Swal from 'sweetalert2';
  import * as XLSX from 'xlsx';
import { gsap } from "gsap";

import axios from 'axios';

  export default {
    name: "AgregarInvitados",
    components: {
      HomeInicio,
    },
    data() {
      
      return {
        paquete: Number(localStorage.getItem('paquete')), // Recupera el paquete de localStorage
        mostrarTodo: true,
        modalAgregarVisible: false,

        invitados: [], // Aquí se guardarán los registros del archivo Excel
        nuevoInvitado: {
          nombre: '',
          idFestejada: localStorage.getItem('id_festejada'), // Asignar aquí

          apellidoP: '',
          apellidoM: '',
          nombreMostrar: '',
          numPase: '',
          numMesa: '',
          telefono: ''
        }  ,    editandoInvitado: null,
        filterNombre: '',
        filterMostrar: '', // Para saber qué invitado está siendo editado,
        vistaTarjetas: false,// Vista actual,
        tarjetaRefs: []



      };
    },

    watch: {
  vistaTarjetas(newVal) {
    if (newVal) {
      this.$nextTick(() => {
        this.tarjetaRefs.forEach((el, index) => {
          if (el) {
            gsap.fromTo(
              el,
              { opacity: 0, y: 30 },
              { opacity: 1, y: 0, duration: 0.6, delay: index * 0.1 }
            );
          }
        });
      });
    }
  }
},

    computed: {
      invitadosFiltrados() {
  const filtro = this.filterNombre.toLowerCase();

  return this.invitados.filter(invitado => {
    const nombreInvitado = invitado.nombre_invitado?.toLowerCase() || '';
    const nombreMostrar = invitado.nombre_mostrar?.toLowerCase() || '';
    const asistira = invitado.asistira?.toLowerCase() || '';

    // Etiqueta en texto para filtrar
    const etiquetaAsistencia = asistira === 'si'
      ? 'confirmado'
      : 'sin confirmar'; // si es 'no' o null o vacío

    return (
      nombreInvitado.includes(filtro) ||
      nombreMostrar.includes(filtro) ||
      etiquetaAsistencia.includes(filtro)
    );
  });
}
,

    
  
    
    totalPases() {
      return this.invitados.reduce((sum, invitado) => sum + Number(invitado.num_pase || 0), 0);
    }
  }
,
    mounted() {
        
        this.idFestejada = localStorage.getItem('id_festejada'); // Carga el valor de localStorage
  if (!this.idFestejada) {
    console.error('ID Festejada no encontrado en localStorage.');
    return;
  }
  this.loadNombrePagina(); // Carga el nombre de la página si idFestejada está disponible
  this.cargarInvitados().then(() => {
    this.cargarAsistencias(); // ✅ Después de invitados
  });
    },
    
    methods: {
 generarLinkWhatsApp(invitado) {
      const telefono = invitado.telefono?.replace(/\D/g, '');
      const urlInvitacion = `${this.nombre_pagina}/${this.idFestejada}/${invitado.id_invitado}`;
      const nombre = invitado.nombre_invitado?.trim() || '';

      let mensaje = '';

      if (this.nombre_pagina.includes('xv')) {
        mensaje = nombre
          ? `¡Hola ${nombre}! Te comparto tu invitación: ${urlInvitacion}`
          : `Te comparto tu invitación: ${urlInvitacion}`;
      } else if (this.nombre_pagina.includes('boda')) {
        mensaje = nombre
          ? `¡Hola ${nombre}! Te compartimos la invitación a nuestra boda: ${urlInvitacion}`
          : `Te compartimos la invitación a nuestra boda: ${urlInvitacion}`;
      } else {
        mensaje = nombre
          ? `¡Hola ${nombre}! Te compartimos tu invitación: ${urlInvitacion}`
          : `Te compartimos tu invitación: ${urlInvitacion}`;
      }

      return telefono ? `https://wa.me/52${telefono}?text=${encodeURIComponent(mensaje)}` : '#';
    },

    // ⬇️ Agrega este método AQUÍ
    abrirWhatsAppEnNuevaVentana(invitado) {
      const url = this.generarLinkWhatsApp(invitado);
      if (url && url !== '#') {
        window.open(url, '_blank');
      } else {
        Swal.fire('Ups', 'Este invitado no tiene número de teléfono.', 'warning');
      }
    },
  


      
      abrirModalAgregar() {
  this.resetearNuevoInvitado(); // 🔥 Limpiar primero
  this.modalAgregarVisible = true; // 🔥 Luego mostrar el modal
},
abrirWhatsApp(invitado) {
  if (!invitado.telefono) {
    return;
  }

  const nombre = invitado.nombre_mostrar || invitado.nombre_invitado || '';
  const mensaje = `¡Hola ${nombre.trim()}! 🥰 Nos haría muchísima ilusión contar con tu presencia en este día tan importante. ¿Podrías confirmarnos si podrás acompañarnos? ✨`;

  const numeroLimpio = invitado.telefono.replace(/\D/g, '');
  const url = `https://wa.me/52${numeroLimpio}?text=${encodeURIComponent(mensaje)}`;

  window.open(url, '_blank');
},
async confirmarBorrado(invitado) {
  const resultado = await Swal.fire({
    title: '¿Estás seguro de borrar este invitado?',
    text: 'Si ya enviaste la invitación, te recomendamos no eliminarlo. Si borras, la URL no podrá recuperarse.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, borrar',
    cancelButtonText: 'Cancelar',
  });

  if (resultado.isConfirmed) {
    try {
      await axios.delete(`${baseUrl}/api2/listainvitados_delete/${invitado.id_invitado}`);
      this.invitados = this.invitados.filter(inv => inv.id_invitado !== invitado.id_invitado);
      Swal.fire('¡Eliminado!', 'El invitado fue eliminado.', 'success');
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'No se pudo eliminar el invitado.', 'error');
    }
  }
}
,

      resetearNuevoInvitado() {
  this.nuevoInvitado = {
    nombre_invitado: '',
    apellidop_invitado: '',
    apellidom_invitado: '',
    nombre_mostrar: '',
    num_pase: '',
    num_mesa: '',
    telefono: ''
  };
},

     


      async cargarAsistencias() {
  const idFestejada = localStorage.getItem('id_festejada');
  if (!idFestejada) {
    console.error('ID Festejada no encontrado.');
    return;
  }

  try {
    const response = await fetch(`${baseUrl}/api2/asistira-si-no?id_festejada=${idFestejada}`);
    if (!response.ok) throw new Error('Error al cargar asistencia');

    const data = await response.json();

    // Fusionar asistencias con invitados
    this.invitados = this.invitados.map(invitado => {
      const match = data.find(a => a.id_invitado === invitado.id_invitado);
      return {
        ...invitado,
        asistira: match ? match.asistira : null,
      };
    });
  } catch (error) {
    console.error('❌ Error al cargar asistencias:', error);
  }
}
,


      async agregarInvitado() {
  const idFestejada = localStorage.getItem('id_festejada');
  const paquete = localStorage.getItem('paquete');  // Recupera el paquete de localStorage

  if (!idFestejada) {
    Swal.fire('Error', 'ID Festejada no encontrado.', 'error');
    return;
  }

  if (!this.nuevoInvitado.nombre_invitado || !this.nuevoInvitado.apellidop_invitado || 
      !this.nuevoInvitado.apellidom_invitado || !this.nuevoInvitado.nombre_mostrar ||
      !this.nuevoInvitado.num_pase || !this.nuevoInvitado.telefono) {
    Swal.fire('Error', 'Todos los campos son obligatorios.', 'error');
    return;
  }

  const invitadoData = {
    idFestejada: idFestejada ,// Usa la variable en lugar de volver a llamar localStorage
    nombre_invitado: this.nuevoInvitado.nombre_invitado,
    apellidop_invitado: this.nuevoInvitado.apellidop_invitado,
    apellidom_invitado: this.nuevoInvitado.apellidom_invitado,
    nombre_mostrar: this.nuevoInvitado.nombre_mostrar,
    num_pase: this.nuevoInvitado.num_pase,
    num_mesa: this.nuevoInvitado.num_mesa,
    telefono: this.nuevoInvitado.telefono,
    paquete: paquete  // Agrega el paquete al objeto

  };

  try {
    const response = await fetch(`${baseUrl}/api2/nuevo/invitados`, { // ✅ Verifica que la ruta sea correcta
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(invitadoData)
    });

    if (!response.ok) {
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error en la API');
      } else {
        const errorText = await response.text();
        throw new Error(`Respuesta inesperada del servidor: ${errorText}`);
      }
    }

    const data = await response.json();
    console.log('Invitado agregado:', data);
    this.cargarInvitados();

    this.invitados.push({ ...data.invitado, isEditing: false });
    this.modalAgregarVisible = false;

    Swal.fire('Éxito', 'Invitado agregado correctamente.', 'success');
    this.limpiarFormulario();
  } catch (error) {
    console.error('Error al agregar invitado:', error);
    Swal.fire('Error', `Hubo un problema: ${error.message}`, 'error');
  }
}
,

 limpiarFormulario() {
      this.nuevoInvitado = {
        nombre_invitado: '',
        apellidop_invitado: '',
        apellidom_invitado: '',
        nombre_mostrar: '',
        num_pase: '',
        num_mesa: '',
        telefono: ''
      };
    },

        copiarUrl(invitado) {
  const url = `${this.nombre_pagina}/${this.idFestejada}/${invitado.id_invitado}`;
  
  navigator.clipboard.writeText(url).then(() => {
    Swal.fire('Copiado', 'La URL ha sido copiada al portapapeles.', 'success');
  }).catch(err => {
    console.error('Error al copiar:', err);
    Swal.fire('Error', 'No se pudo copiar la URL.', 'error');
  });
},

        async guardarEdicion(invitado) {
  if (!invitado.id_invitado) {
    Swal.fire('Error', 'ID de invitado no encontrado.', 'error');
    return;
  }

  const confirmUpdate = await Swal.fire({
    title: '¿Estás seguro?',
    text: "¿Quieres guardar los cambios?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, guardar',
    cancelButtonText: 'Cancelar'
  });

  if (confirmUpdate.isConfirmed) {
    try {
      // Limpieza antes del PUT
invitado.num_mesa = invitado.num_mesa === '' ? null : Number(invitado.num_mesa);
invitado.num_pase = invitado.num_pase === '' ? null : Number(invitado.num_pase);
      const response = await fetch(`${baseUrl}/api2/invitadosact/${invitado.id_invitado}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(invitado)
        
      });
      console.log(`Enviando PUT a: ${baseUrl}/api2/invitadosact/${invitado.id_invitado}`);
      console.log('Datos enviados:', JSON.stringify(invitado));
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error en la respuesta del servidor: ${errorText}`);
      }

      const result = await response.json();

      // Encuentra el índice y actualiza el estado de edición
      const index = this.invitados.findIndex(i => i.id_invitado === invitado.id_invitado);
      if (index !== -1) {
        this.invitados[index] = { ...invitado, isEditing: false };
      }

      Swal.fire('Éxito', result.message || 'Invitado actualizado correctamente.', 'success');

    } catch (error) {
      console.error('Error al actualizar el invitado:', error);
      Swal.fire('Error', `Hubo un error al actualizar: ${error.message}`, 'error');
    }
  } else {
    // 🔹 Cancelar edición: Restaurar datos originales y ocultar los inputs
    const index = this.invitados.findIndex(i => i.id_invitado === invitado.id_invitado);
    if (index !== -1 && this.invitados[index].original) {
      this.invitados[index] = { ...this.invitados[index].original, isEditing: false };
    } else {
      invitado.isEditing = false; // Oculta los inputs si no hay datos originales
    }

    // 🔹 Forzar actualización del estado en Vue
    this.$forceUpdate(); 
  }
}
,

descargarExcel() {
     const wb = XLSX.utils.book_new();  // Crea un nuevo libro de trabajo (workbook)
     
     // Convierte los datos de los invitados en una hoja de cálculo
     const ws = XLSX.utils.json_to_sheet(this.invitados.map(invitado => ({
       Nombre: invitado.nombre_invitado,
       'Apellido P': invitado.apellidop_invitado,
       'Apellido M': invitado.apellidom_invitado,
       'Nombre Mostrar': invitado.nombre_mostrar,
       'Num Pase': invitado.num_pase,
       'Num Mesa': invitado.num_mesa,
       Telefono: invitado.telefono,
       Url: `${this.nombre_pagina}/${this.idFestejada}/${invitado.id_invitado}`
     })));
     
     // Agrega la hoja al libro
     XLSX.utils.book_append_sheet(wb, ws, 'Invitados');
     
     // Genera el archivo Excel y lo descarga
     XLSX.writeFile(wb, 'invitados.xlsx');
   },

        async cargarInvitados() {
  const idFestejada = localStorage.getItem('id_festejada');
  if (!idFestejada) {
    console.error('ID Festejada no encontrado en localStorage.');
    return;
  }
  
  
  try {
    const response = await fetch(`${baseUrl}/api2/invitados?id_festejada=${idFestejada}`);
    if (!response.ok) {
      throw new Error('Error al cargar la lista de invitados');
    }
    const data = await response.json();
      // Añadimos la propiedad isEditing a cada invitado
      this.invitados = data.map(invitado => ({
      ...invitado,
      isEditing: false // Inicializamos isEditing como false
    }));
  } catch (error) {
    console.error('Error al cargar los invitados:', error);
  }
},

async loadNombrePagina() {
        try {
          const response = await fetch(`${baseUrl}/obtener-nombre-pagina2/${this.idFestejada}`);
          
          if (!response.ok) {
            throw new Error('Error al obtener el campo adicional');
          }
          const data = await response.json();
          this.nombre_pagina = data.nombre_pagina; // Almacena el resultado en el estado
        } catch (error) {
          console.error('Error:', error);
        }
      },
  
      editarInvitado(invitado) {
  invitado.isEditing = true;  // Marca el invitado como en edición
  // Copiar los valores originales para que si el usuario decide cancelar, los valores no se pierdan
  invitado.original = { ...invitado }; // Guarda el estado original de los datos
},
    
  
     
    },
  };
  </script>
  
  <style scoped>
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    font-family: "Poppins", sans-serif;
    background-color: #fdfcfa;
  }
  
  .container {
    padding-top: 100px;
    width: 100%;
    padding-bottom: 85px;
  }
  
  .add-invitados-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto 60px;
  padding: 40px 0px; /* ← aquí el cambio clave */
  background: rgba(255, 255, 255, 0.75);
  border-radius: 20px;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 14px 38px rgba(0, 0, 0, 0.06);
  text-align: center;
  overflow-x: hidden;
}


  .title {
font-family: 'Playfair Display', serif;
    font-size: 32px;
    color: #4a3f42;
    font-weight: 500;

    margin-bottom: 8px;

  }
  
  .description {
    font-size: 15px;
    color: #555;
    font-family: "Poppins", sans-serif;
    margin-bottom: 20px;
  }
  .header-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.filters input {
  padding: 8px 14px;
  font-size: 14px;
  border-radius: 12px;
  border: 1px solid #ccc;
}

.invitados-count p {
  margin: 0;
  font-size: 14px;
  color: #5f6770;
  font-family: 'Poppins', sans-serif;
}
.table {
  width: 100%;
  min-width: 1200px; /* o más si tienes muchas columnas */

  table-layout: auto; /* ❌ evita table-layout: fixed */
  border-collapse: collapse;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  margin-top: 20px;
  min-width: unset; /* ✅ elimina el ancho mínimo forzado */

}

.table-wrapper {
  width: 100%;
  overflow-x: auto; /* por si acaso */
}
.table td input {
  width: 100%;
  max-width: 120px; /* Controla el desborde */
  font-size: 12px;  /* Ajusta el texto */
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  background-color: #fff;
  box-sizing: border-box;
  text-align: center;
}

.table th,
.table td {
  padding: 8px;
  text-align: center;
  font-size: 10px;
  font-family: 'Poppins', sans-serif;
  white-space: normal; /* permite saltos de línea */
  word-break: break-word; /* evita que el contenido se desborde */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}



.table th {
  background-color: #5f6770;
  color: white;
}


/* Botones con tu branding */
.action-buttons {
  display: flex;
  justify-content: center;
   display: flex;
  align-items: center;
  gap: 6px; /* Espaciado uniforme */
}

.btn-outline {
  background-color: transparent;
  border: 1px solid #5f6770;
  color: #5f6770;
  border-radius: 20px;
  padding: 6px 12px;
    height: 40px;              /* Igual altura que el botón rojo */

  font-size: 13px;
  font-family: 'Playfair Display', serif;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background-color: #5f6770;
  color: white;
}

.btn-outline-secondary {
  background-color: transparent;
  border: 1px solid #b8a4b3;
  color: #b8a4b3;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 13px;
  font-family: 'Playfair Display', serif;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-outline-secondary:hover {
  background-color: #b8a4b3;
  color: white;
}


.form-container {
  margin-top: 30px;
  padding: 30px 24px;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 24px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index:20;

  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.08);
}

h3 {
  font-family: "Playfair Display", serif;
  text-align: center;
  font-size: 12px;
  margin-bottom: 24px;
  color: #4a3f42;
}

.form-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}

label {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 6px;
  color: #4a3f42;
  font-family: 'Playfair Display', serif;
}

input {
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #ccc;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  outline: none;
  transition: border-color 0.3s ease;
}

input:focus {
  border-color: #b8a4b3;
}

.btn-success {
  background-color: #5f6770;
  color: white;
  padding: 15px 20px;
  border: none;
  border-radius: 32px;
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease-in-out;
  margin-top: 20px;
}
.btn-submit:hover {
  background-color: #857b85;
  transform: translateY(-2px);
}
  .btn-download {
    background-color: #5f6770;
    color: white;
    padding: 8px 16px;
    font-size: 14px;
    border: none;
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
  }
  
  .btn-download:hover {
    background-color: #4a545e;
  }
  



  .form-title {
    font-family: 'serenety', cursive;
  font-size: 46px;
  font-weight: 500;
  color: #4a3f42;
  text-align: center;
  flex: 1; /* ✅ para que ocupe todo el espacio horizontal */
  margin: 0;
}
.btn-download {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px; /* menos padding */
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 20px; /* menos redondeado */
  font-size: 14px; /* más pequeño */
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.btn-download:hover {
  background-color: #45a049;
}

.download-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 50%;
}
.add-invitados-container.compact {
  max-width: 800px; /* más angosto cuando está en modo compacto */
  transition: max-width 0.3s ease;
}

.invitados-count strong {
  color: #5f6770;
  font-weight: 700;
  font-size: 15px;
}


.badge-confirmado,
.badge-sinconfirmar {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  margin-bottom: 4px;
}

.badge-confirmado {
  background-color: #4a3f42;
  color: white;
}

.badge-sinconfirmar {
  background-color: #d5d5d5;
  color: #333;
}


.tooltip-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

.tooltip-icon {
  background-color: #5f6770;
  color: white;
  font-size: 12px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 18px;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  transition: background 0.3s ease;
}

.tooltip-icon:hover {
  background-color: #4a3f42;
}

.custom-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 40px;
  left: 0;
  background-color: white;
  color: #333;
  font-size: 12px;
  padding: 10px 14px;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
  transition: opacity 0.3s ease;
  width: max-content;
  max-width: 240px;
  z-index: 10;
  font-family: 'Poppins', sans-serif;
  border: 1px solid #ddd;
}

.tooltip-container:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* 👈 Este valor lo pone encima de todo */
}

.modal-contenido {
  background: white;
  border-radius: 14px;
  padding: 18px 20px;
  width: 100%;
  max-width: 380px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: fadeInUp 0.35s ease;
  font-family: 'Poppins', sans-serif;
  max-height: 90vh;
  overflow-y: auto;
  z-index:20;
}



.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.btn-cerrar {
  background: transparent;
  border: none;
  font-size: 28px;
  font-weight: bold;
  color: #888;
  cursor: pointer;
}
.modal-contenido input {
  width: 100%;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  transition: all 0.3s ease;
  height: 32px;
}

.modal-contenido input:focus {
  outline: none;
  border-color: #5f6770;
  box-shadow: 0 0 3px rgba(95, 103, 112, 0.25);
}

.form-row {
  margin-bottom: 10px;
}




@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.agregar-btn-wrapper {
  display: flex;
  justify-content: flex-end; /* ✅ alinea a la derecha */
  margin-top: 10px;
  margin-bottom: 20px;
  padding-right: 20px;
}

.btn-agregar-invitado {
  background-color: #b8a4b3; /* rosa empolvado */
  border: 1px solid #b8a4b3;
  color: white;
  padding: 6px 16px;
  font-size: 13px;
  font-family: 'Playfair Display', serif;
  border-radius: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.btn-agregar-invitado:hover {
  background-color: #a6909f;
  border-color: #a6909f;
  color: white;
}

.icono-mas {
  font-size: 16px;
  font-weight: bold;
  transform: translateY(-1px);
}
.tarjetas-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
}

.tarjeta-invitado {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  padding: 20px;
  width: 100%;
  max-width: 300px;
  transition: transform 0.3s ease;
  font-family: 'Poppins', sans-serif;
}

.tarjeta-invitado:hover {
  transform: translateY(-4px);
}

.status-badge {
  text-align: right;
  margin-bottom: 10px;
}


.nombre-mostrar-tag {
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  font-size: 22px;
  display: inline-block;
  margin-top: 4px;
  color:#000000;
}


.telefono-rojo {
  color: #e53935;
  font-weight: 500;
}

.phone-icon {
  color: #e53935;
  margin-right: 5px;
}

.mesa-circle {
  display: inline-block;

  font-weight: 600;
  margin-left: 5px;
}
.btn-borrar-personalizado {
  background-color: #c30000;
  border: none;
  border-radius: 50%;
  color: white;
  width: 40px;
  height: 40px;
  position: relative;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.btn-borrar-personalizado::before {
  content: '';
  position: absolute;
  left: -10px;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
}
.btn-borrar-personalizado:hover {
  transform: scale(1.1);
}


.btn-success {
  background-color: #25d366;
  color: white;
  border: none;
  border-radius: 20px;
  height: 40px;
  min-width: 40px;
  padding: 0 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0; /* Elimina cualquier offset */
  line-height: 1; /* Alineación más precisa */
  vertical-align: middle;
}
.btn-guardar {
  background-color: #007bff; /* Azul, o el color que prefieras */
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.btn-guardar:hover {
  transform: scale(1.05);
}


  </style>